import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link, useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addAsset, getAsset } from "./Services/assetsService";
import { GetMasterTypeData, uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

const AddAssets = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  let history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const { GUId } = useParams();
  const [dashboardCount, setDashboardCount] = useState({});
  const [ticketData, setTicketData] = useState([]);
  const [assestId, setAssestId] = useState([])
  const [assestStatusType, setAssestStatusType] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [assestType, setAssestType] = useState([])
  useEffect(() => {
    getAssetStatusCategory()
    getAssetTypeCategory()
    if (GUId) {
      getAssestList()
    }
  }, [GUId]);

  async function getAssetStatusCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "AssetStatus",
    };
    try {
      const data = await GetMasterTypeData(params);
      setAssestStatusType(data?.Data);
      // const firstCategory = data?.Data?.[0];
      // if (firstCategory) {
      //   setSelectedCategoryId(firstCategory.Id);
      // }
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
      setIsloading(false);
    }
  }


  async function getAssetTypeCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "AssetType",
    };
    try {
      const data = await GetMasterTypeData(params);
      setAssestType(data?.Data);
      // const firstCategory = data?.Data?.[0];
      // if (firstCategory) {
      //   setSelectedCategoryId(firstCategory.Id);
      // }
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
      setIsloading(false);
    }
  }

  async function getAssestList() {
    setIsloading(true);
    const params = {
      OrgId: userDetails.OrgId,
      LoggedInUserId: userDetails.OrgId,
      SearchTerm: "",
      GuId: GUId,
      PageNumber: 1,
      PageSize: 10,
    };

    try {
      let response = await getAsset(params);

      const dashboard = response?.Data?.invDashboardCount || {};
      const AssetsList = response?.Data?.invListResponses || [];
      console.log(dashboard, "dashboard")
      console.log(AssetsList, "AssetsList")
      let docs = AssetsList?.Document?.map(
        (doc) => doc?.Document
      ).join(",");
      setAssestId(AssetsList.Id);
      // const AnnouncementValue = {
      //   itemTypeName: AssetsList.ItemName,
      //   serial_Number: AssetsList.SerialNumber,
      //   // Asset_Tally_Name: AssetsList.,
      //   address: AssetsList.,
      //   description: AssetsList.Description,
      //   warranty_contact_person: AssetsList.,
      //   warranty_Last_date: AssetsList.invPHResponses[0].WarrantyLastDate,
      //   warranty_Number: AssetsList.invPHResponses[0].WarrantyContactNumber,
      //   units: AssetsList.,
      //   purchase_Date: AssetsList.,
      //   modal: AssetsList.Model,
      //   make: AssetsList.Make,
      //   storage: AssetsList.,
      //   other1_ram: Other1,
      //   other2_Processor: AssetsList.Other2,
      //   other3_Operating: AssetsList.Other3,
      //   other4: AssetsList.Other4,
      //   other5: AssetsList.Other5,
      //   other6: AssetsList.Other6,
      //   discard_Date: AssetsList.,
      //   vendor: AssetsList.invPHResponses[0].VendorName,
      //   Document: AssetsList.
      // };
      // AssetsForm.setValues(AnnouncementValue);

      // setDashboardCount(dashboard);
      // setTicketData(list);

      // // IMPORTANT: total count from API
      // setTotalRecords(dashboard?.TotalAssets || 0);

    } catch (error) {
      console.log(error);
    }

    setIsloading(false);
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      // else if (msg?.Name == message && type == 1) {
      // 	setErrorMessage(msg?.Desc);
      // }
      // else if (msg?.Name == message && type == 2) {
      // 	setMasterSystemAlertData(msg?.Desc);
      // }
    });
  }, []);

  const validationSchema = Yup.object({
    itemTypeName: Yup.string().required("Type is required"),
    serial_Number: Yup.string().required("Serial number is required"),
    purchase_Date: Yup.date().required("Purchase date is required"),
    warranty_Last_date: Yup.date().nullable(),
    units: Yup.number().required("Units required"),
    Asset_Tally_Name: Yup.string().required("Type is required"),
    address: Yup.string().required("Type is required"),
    warranty_contact_person: Yup.string().required("Type is required"),
    warranty_Number: Yup.string().required("Type is required"),
    discard_Date: Yup.string().required("Type is required"),
    modal: Yup.string().required("Type is required"),
    other3_Operating: Yup.string().required("Type is required"),
  });

  const AssetsForm = useFormik({
    initialValues: {
      itemTypeName: "",
      serial_Number: "",
      Asset_Tally_Name: "",
      address: "",
      description: "",
      warranty_contact_person: "",
      warranty_Last_date: "",
      warranty_Number: "",
      units: "",
      purchase_Date: "",
      modal: "",
      make: "",
      storage: "",
      other1_ram: "",
      other2_Processor: "",
      other3_Operating: "",
      other4: "",
      other5: "",
      other6: "",
      discard_Date: "",
      vendor: "",
      Document: ""

    },
    validationSchema: validationSchema,
    onSubmit: async (data) => {
      const documents = AssetsForm.values.Document
        ? AssetsForm.values.Document.split(",").map((doc) => doc.trim())
        : [];
      setIsloading(true);
      const body = {
        Id: data?.Id ?? 0,
        OrgId: userDetails.OrgId,
        ItemTypeId: Number(data.itemTypeName),
        ItemName: "",
        SerialNumber: data.serial_Number,
        // Type: data.Asset_Tally_Name,
        MacAddress: data.address,
        Description: data.description,
        WarrantyContactPerson: data.warranty_contact_person,
        WarrantyLastDate: data.warranty_Last_date,
        WarrantyContactNumber: data.warranty_Number,
        ItemQuantity: Number(data.units),
        DateOfPurchase: data.purchase_Date,
        Model: data.modal,
        Make: data.make,
        Size: data.storage,
        Other1: data.other1_ram,
        Other2: data.other2_Processor,
        Other3: data.other3_Operating,
        Other4: data.other4,
        Other5: data.other5,
        Other6: data.other6,
        StatusId: Number(data.statusId) || 0,
        Document: documents,
        VendorId: 105, //Number(data.vendor) ?? 0,
        BatchNo: "",
        CreatedBy: userDetails?.Id || 0,
      };

      try {
        const response = await addAsset(body);

        if (response) {
          GetMasterSystemAlertList("Announcement_added", 0);
          history.push("/Assets/Detail");
        }
      } catch (error) {
        console.log(error);
        toster.current.error("Something went wrong");
      } finally {
        setIsloading(false);
      }
    }
  });

  const [file, setFile] = useState(null);
  const [type, setType] = useState(null);
  const inputFile = React.useRef(null);

  const fileTypes = [
    { ext: "doc", name: "Doc", icon: "/images/tickets/doc.JPG" },
    { ext: "docx", name: "Docx", icon: "/images/tickets/doc.JPG" },
    { ext: "zip", name: "Zip", icon: "/images/tickets/zip.png" },
    { ext: "pdf", name: "Pdf", icon: "/images/tickets/pdf.png" },
    { ext: "xls", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "xlsx", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "csv", name: "Excel CSV", icon: "/images/tickets/excel.png" },
  ];

  const handleFileChangeDoc = (event) => {
    const files = event.target.files;
    const fileArray = Array.from(files);

    if (fileArray.length > 0) {
      setFile(fileArray);
      setType(1);
    }
  };

  useEffect(() => {
    if (file) {
      uploadPolicyDocFile(type);
    }
  }, [file]);


  async function uploadPolicyDocFile(type) {
    setIsloading(true);

    if (file) {
      const formData = new FormData();

      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }

      let params = {
        UploadType: UploadFile_KEYS?.Assets, // change if needed
        RefId: 0,
      };

      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data.map((url) => url.replace(/%22/g, ""));;

        if (AssetsForm.values.Document) {
          const existingDocuments = AssetsForm.values.Document.split(",").map(
            (doc) => doc.trim()
          );

          const updatedDocuments = [
            ...new Set([...existingDocuments, ...ImageURL]),
          ];

          const documentValue = updatedDocuments.join(", ");

          AssetsForm.setFieldValue("Document", documentValue);
        } else {
          const documentValue = ImageURL.join(", ");

          AssetsForm.setFieldValue("Document", documentValue);
        }

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error("Upload failed");
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected");
    }
  }

  const deleteFile = (fileUrl) => {
    const files = AssetsForm.values.Document.split(",").map((x) => x.trim());

    const updated = files.filter((f) => f !== fileUrl);

    AssetsForm.setFieldValue("Document", updated.join(", "));
  };

  return (
    <div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add Asset</h2>
            </div>
            <div className="rightside-tabs">
              <Link to="/Assets/List">
                <button className="back-newticket w-auto float-right">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    />
                  </svg>{" "}
                  Back
                </button>
              </Link>
            </div>
          </div>
          <div className="edit-ticket mt-4 mb-4">
            <div className="w-100">
              <form onSubmit={AssetsForm.handleSubmit}>
                <div className="row">
                  <div className="col-md-8">
                    <div className="employee-card tile-grid tile-grid-v1">
                      <div id="feed-post-1" className="addticketform">
                        <div className="third-section">
                          <div className="row gx-3 gy-1">
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  {" "}
                                  Type<i className="inValidError">*</i>
                                </label>

                                <select
                                  className="form-select"
                                  name="itemTypeName"
                                  value={AssetsForm.values.itemTypeName}
                                  onChange={AssetsForm.handleChange}
                                >
                                  <option value="">Select Type</option>
                                  {assestType.map((item) => (
                                    <option key={item.Id} value={item.Id}>
                                      {item.Name}
                                    </option>
                                  ))}
                                </select>

                                {/* <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="itemTypeName"
                                  placeholder="type of assets"
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.itemTypeName}
                                /> */}
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.itemTypeName &&
                                  AssetsForm.touched.itemTypeName
                                  ? AssetsForm.errors.itemTypeName
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  {" "}
                                  Serial Number<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="serial_Number"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.serial_Number &&
                                      AssetsForm.touched.serial_Number
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.serial_Number}
                                  placeholder="Serial Number"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.serial_Number &&
                                  AssetsForm.touched.serial_Number
                                  ? AssetsForm.errors.serial_Number
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  Asset Name<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="Asset_Tally_Name"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.Asset_Tally_Name &&
                                      AssetsForm.touched.Asset_Tally_Name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.Asset_Tally_Name}
                                  placeholder="Asset tally name"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.Asset_Tally_Name &&
                                  AssetsForm.touched.Asset_Tally_Name
                                  ? AssetsForm.errors.Asset_Tally_Name
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  Mac Address<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="address"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.address &&
                                      AssetsForm.touched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.address}
                                  placeholder="Mac Address"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.address &&
                                  AssetsForm.touched.address
                                  ? AssetsForm.errors.address
                                  : null}
                              </div>
                            </div>

                            <div className="mb-3 col-md-12">
                              <div className="cover-form">
                                <label className="form-label">
                                  Description
                                </label>
                                <textarea
                                  rows="6"
                                  cols="1"
                                  name="description"
                                  className="form-control"
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.description}
                                  placeholder="Description of asset"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="row gx-3 gy-1 mt-3">
                            <h4 className="">System Information</h4>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Contact person<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="text"
                                  name="warranty_contact_person"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.warranty_contact_person &&
                                      AssetsForm.touched.warranty_contact_person
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.warranty_contact_person}
                                  placeholder="Warranty Contact person"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.warranty_contact_person &&
                                  AssetsForm.touched.warranty_contact_person
                                  ? AssetsForm.errors.warranty_contact_person
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Last date
                                </label>
                                <input
                                  type="date"
                                  name="warranty_Last_date"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.warranty_Last_date &&
                                      AssetsForm.touched.warranty_Last_date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.warranty_Last_date}
                                  placeholder="Warranty Last date"
                                />
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Number<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="number"
                                  name="warranty_Number"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.warranty_Number &&
                                      AssetsForm.touched.warranty_Number
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.warranty_Number}
                                  placeholder="Warranty number"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.warranty_Number &&
                                  AssetsForm.touched.warranty_Number
                                  ? AssetsForm.errors.warranty_Number
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">Units<i className="inValidError">*</i></label>
                                <input
                                  type="number"
                                  name="units"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.units &&
                                      AssetsForm.touched.units
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.units}
                                  placeholder="Units"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.units &&
                                  AssetsForm.touched.units
                                  ? AssetsForm.errors.units
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Discard Date
                                </label>
                                <input
                                  type="date"
                                  onClick={(e) =>
                                    e.target.showPicker && e.target.showPicker()
                                  }
                                  name="discard_Date"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.discard_Date &&
                                      AssetsForm.touched.discard_Date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.discard_Date}
                                  placeholder="Discard Date"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.discard_Date &&
                                  AssetsForm.touched.discard_Date
                                  ? AssetsForm.errors.discard_Date
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Date of Purchase<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="date"
                                  name="purchase_Date"
                                  onClick={(e) =>
                                    e.target.showPicker && e.target.showPicker()
                                  }
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.purchase_Date &&
                                      AssetsForm.touched.purchase_Date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.purchase_Date}
                                  placeholder="Date of Purchase"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.purchase_Date &&
                                  AssetsForm.touched.purchase_Date
                                  ? AssetsForm.errors.purchase_Date
                                  : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12 mt-3">
                            <div className="row gx-3 gy-1 mb-3">
                              <h4 className="">Laptop/Desktop Information</h4>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Modal(Brand)<i className="inValidError">*</i>
                                  </label>
                                  <input
                                    type="text"
                                    name="modal"
                                    className={
                                      "form-control" +
                                      (AssetsForm.errors.modal &&
                                        AssetsForm.touched.modal
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.modal}
                                    placeholder="Brand"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {AssetsForm.errors.modal &&
                                    AssetsForm.touched.modal
                                    ? AssetsForm.errors.modal
                                    : null}
                                </div>
                              </div>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Make(Gen)
                                  </label>
                                  <input
                                    type="text"
                                    name="make"
                                    className="form-control "
                                    placeholder="make"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.make}
                                  />
                                </div>
                              </div>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Size (Storage)
                                  </label>
                                  <input
                                    type="text"
                                    name="storage"
                                    className="form-control "
                                    placeholder="storage"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.storage}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row gx-3 gy-1">
                              <h4 className="">Make Modal</h4>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 1 (Ram)
                                  </label>
                                  <input
                                    type="text"
                                    name="other1_ram"
                                    className="form-control "
                                    placeholder="Ram"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other1_ram}
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 2 (Processor)
                                  </label>
                                  <input
                                    type="text"
                                    name="other2_Processor"
                                    className="form-control "
                                    placeholder="Processor"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other2_Processor}
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 3 (Operating System)<i className="inValidError">*</i>
                                  </label>
                                  <input
                                    type="text"
                                    name="other3_Operating"
                                    className={
                                      "form-control" +
                                      (AssetsForm.errors.other3_Operating &&
                                        AssetsForm.touched.other3_Operating
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other3_Operating}
                                    placeholder="Operating System"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {AssetsForm.errors.other3_Operating &&
                                    AssetsForm.touched.other3_Operating
                                    ? AssetsForm.errors.other3_Operating
                                    : null}
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 4</label>
                                  <input
                                    type="text"
                                    name="other4"
                                    className="form-control "
                                    placeholder="other4"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other4}
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 5 </label>
                                  <input
                                    type="text"
                                    name="other5"
                                    className="form-control "
                                    placeholder="other5"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other5}
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 6 </label>
                                  <input
                                    type="text"
                                    name="other6"
                                    className="form-control "
                                    placeholder="Operating System"
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.other6}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row justify-content-end">
                            <div className="col-md-3">
                              <button
                                className="btn btn-purple btn-block"
                                type="submit"
                                disabled={Isloading}
                              >
                                {Isloading ? "Saving..." : "Submit"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header bg-transparent border-bottom-0">
                        <h4 className="">Status</h4>
                      </div>
                      <div className="card-body">
                        <div>
                          <select
                            className="form-select"
                            name="statusId"
                            value={AssetsForm.values.statusId}
                            onChange={AssetsForm.handleChange}
                          >
                            <option value="">Select Status</option>

                            {assestStatusType.map((item) => (
                              <option key={item.Id} value={item.Id}>
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <h5 className="">Owner Detail</h5>
                        <div className="assets-attach__wrapper">
                          <div className="option-g">
                            <div className="info mb-0">
                              <div className="info__items_detail">
                                <div className="image">
                                  <img
                                    src="http://devbox.bizbrolly.com:4006/Uploads/c737/PI/101\cropped_c9df_202508202430.jpg"
                                    alt="zip.png"
                                  />
                                </div>
                                <div className="div">
                                  <h6>Liam Shep Thompson</h6>
                                  <span>On&nbsp;Oct 31 2025</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header bg-transparent border-bottom-0">
                        <h4>Assets Image and Files</h4>
                      </div>

                      <div className="card-body">

                        {/* Uploaded Files */}
                        {AssetsForm.values.Document && (
                          <div className="announcement-attchment">

                            {AssetsForm.values.Document.split(",").map((fileUrl, index) => (
                              <div className="filediv" key={index}>

                                <div className="file_detail">
                                  <span>
                                    <a href={fileUrl} target="_blank">
                                      View File {index + 1}
                                    </a>
                                  </span>
                                </div>

                                <div>
                                  <i
                                    className="fa fa-trash"
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={() => deleteFile(fileUrl)}
                                  ></i>
                                </div>

                              </div>
                            ))}

                          </div>
                        )}

                        {/* Upload Button */}
                        <label
                          htmlFor="file-upload"
                          className="custom-file-upload"
                        >
                          <i className="fa fa-upload me-2"></i>
                          Upload multiple Image and files
                        </label>

                        <input
                          ref={inputFile}
                          type="file"
                          multiple
                          id="file-upload"
                          className="form-control"
                          accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx"
                          style={{ display: "none" }}
                          onChange={handleFileChangeDoc}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAssets;
